import React from 'react';
import { Routes, Route } from 'react-router';
import { ErrorComponent } from '@refinedev/antd';
import { getPublicRoutes } from './public';
import { getProtectedRoutes } from './protected';
import { ROUTES, RESOURCES } from './constants';

export { ROUTES, RESOURCES };

export const AppRoutes = () => (
  <Routes>
    {getPublicRoutes()}
    {getProtectedRoutes()}
    <Route path="*" element={<ErrorComponent />} />
  </Routes>
);
